// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CompanyOtherInfo,
    CompanyOtherInfoFromJSON,
    CompanyOtherInfoToJSON,
    CompanyStripeInfo,
    CompanyStripeInfoFromJSON,
    CompanyStripeInfoToJSON,
    CompanyTrialDetails,
    CompanyTrialDetailsFromJSON,
    CompanyTrialDetailsToJSON,
    CompanyUsageDetails,
    CompanyUsageDetailsFromJSON,
    CompanyUsageDetailsToJSON,
    User,
    UserFromJSON,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    plan: CompanyPlanEnum;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    planStatus: CompanyPlanStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    billingEmail: string;
    /**
     * 
     * @type {CompanyTrialDetails}
     * @memberof Company
     */
    trialDetails: CompanyTrialDetails;
    /**
     * 
     * @type {CompanyUsageDetails}
     * @memberof Company
     */
    usageDetails: CompanyUsageDetails;
    /**
     * 
     * @type {CompanyStripeInfo}
     * @memberof Company
     */
    stripeInfo?: CompanyStripeInfo;
    /**
     * (for billing)
     * @type {string}
     * @memberof Company
     */
    address: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof Company
     */
    city: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof Company
     */
    state: string;
    /**
     * (for billing)
     * @type {string}
     * @memberof Company
     */
    country: string;
    /**
     * 
     * @type {User}
     * @memberof Company
     */
    owner?: User;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    trialOpted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    trialStartedOn?: string;
    /**
     * 
     * @type {CompanyOtherInfo}
     * @memberof Company
     */
    otherInfo?: CompanyOtherInfo;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    createdAt?: string;
    /**
     * Stringified JSON object
     * @type {string}
     * @memberof Company
     */
    stats?: string;
    /**
     * Indicates if the company has completed the onboarding process
     * @type {boolean}
     * @memberof Company
     */
    isOnboarded?: boolean;
    /**
     * Stringified JSON object
     * @type {string}
     * @memberof Company
     */
    onboardingInfo?: string;
    /**
     * Which onboarding journey this account was given. Assigned once, when the account is created, and never changed afterwards.
     * @type {string}
     * @memberof Company
     */
    onboardingVariant?: string;
}

export function CompanyFromJSON(json: any): Company {
    return {
        'id': json['id'],
        'name': json['name'],
        'plan': json['plan'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'planStatus': json['planStatus'],
        'billingEmail': json['billingEmail'],
        'trialDetails': CompanyTrialDetailsFromJSON(json['trialDetails']),
        'usageDetails': CompanyUsageDetailsFromJSON(json['usageDetails']),
        'stripeInfo': !exists(json, 'stripeInfo') ? undefined : CompanyStripeInfoFromJSON(json['stripeInfo']),
        'address': json['address'],
        'city': json['city'],
        'state': json['state'],
        'country': json['country'],
        'owner': !exists(json, 'owner') ? undefined : UserFromJSON(json['owner']),
        'trialOpted': !exists(json, 'trial_opted') ? undefined : json['trial_opted'],
        'trialStartedOn': !exists(json, 'trial_started_on') ? undefined : json['trial_started_on'],
        'otherInfo': !exists(json, 'other_info') ? undefined : CompanyOtherInfoFromJSON(json['other_info']),
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'stats': !exists(json, 'stats') ? undefined : json['stats'],
        'isOnboarded': !exists(json, 'is_onboarded') ? undefined : json['is_onboarded'],
        'onboardingInfo': !exists(json, 'onboarding_info') ? undefined : json['onboarding_info'],
        'onboardingVariant': !exists(json, 'onboarding_variant') ? undefined : json['onboarding_variant'],
    };
}

export function CompanyToJSON(value?: Company): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'plan': value.plan,
        'size': value.size,
        'planStatus': value.planStatus,
        'billingEmail': value.billingEmail,
        'trialDetails': CompanyTrialDetailsToJSON(value.trialDetails),
        'usageDetails': CompanyUsageDetailsToJSON(value.usageDetails),
        'stripeInfo': CompanyStripeInfoToJSON(value.stripeInfo),
        'address': value.address,
        'city': value.city,
        'state': value.state,
        'country': value.country,
        'owner': UserToJSON(value.owner),
        'trial_opted': value.trialOpted,
        'trial_started_on': value.trialStartedOn,
        'other_info': CompanyOtherInfoToJSON(value.otherInfo),
        'created_at': value.createdAt,
        'stats': value.stats,
        'is_onboarded': value.isOnboarded,
        'onboarding_info': value.onboardingInfo,
        'onboarding_variant': value.onboardingVariant,
    };
}

/**
* @export
* @enum {string}
*/
export enum CompanyPlanEnum {
    Free = 'free',
    Premium = 'premium'
}
/**
* @export
* @enum {string}
*/
export enum CompanyPlanStatusEnum {
    Active = 'active',
    Expired = 'expired',
    Trial = 'trial'
}


